import React from "react";

interface Props {
  className?: string;
  onClick?: () => void;
}

const Close: React.FC<Props> = (props) => (
  <svg
    onClick={props.onClick}
    className={props.className || "w-4 h-4 stroke-current defaultText"}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
  </svg>
);

export default Close;
